import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import { Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import { AppVersion, AuthFormWrapper, HelperWrapper } from 'src/components'
import { SignInEmailForm } from './sign-in-email-form.component'
import { useConfirmLoginByProvider, useSendNewEmailVerification } from 'src/hooks'
import { TrackgoodLogo } from 'src/assets/icons'

import { signInEmailSchema } from 'src/common/validations'
import { ISignInEmailVerification } from 'src/types'
import { AppEvents, FONTS, ROUTES, SPACES } from 'src/constants'
import { getEncodedQueryParam } from 'src/common/utils'

import { useStyles } from '../styles'

const SignInEmail = () => {
  const [t] = useTranslation()
  const theme = useTheme()
  const [searchParams] = useSearchParams()
  const { data: verificationResp, mutateAsync: sendNewEmailVerification } =
    useSendNewEmailVerification()
  const { mutate: confrimLoginByProvider } = useConfirmLoginByProvider()
  const navigate = useNavigate()
  const email = getEncodedQueryParam('email')

  // Styling
  const classes = useStyles()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const handleSubmit = async (values: ISignInEmailVerification) => {
    const id = searchParams.get('userId')

    if (!id) {
      const detail = { message: t('sign-in-email-error-message') }

      const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
      document.dispatchEvent(event)

      return navigate(ROUTES.LOGIN)
    }

    if (email) {
      return confrimLoginByProvider({ email, id })
    }

    await sendNewEmailVerification({ ...values, id })
  }

  return (
    <Grid
      item
      xs={isLaptop ? 12 : 6}
      px={isLaptop ? SPACES.xxxl : 0}
      className={classes.contentWrapper}
    >
      <Grid
        display={isLaptop ? 'none' : 'flex'}
        justifyContent="flex-end"
        className={classes.signUpContainer}
      >
        <Typography className={classes.textSignUp} alignItems={'center'}>
          <HelperWrapper t="sign-in-email-opposite-text" />{' '}
          <Link style={{ textDecoration: 'none' }} to={ROUTES.LOGIN}>
            <Button className={classes.buttonSignUp}>
              <HelperWrapper t="login-link-text" />
            </Button>
          </Link>
        </Typography>
      </Grid>
      <AuthFormWrapper>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid>
            <TrackgoodLogo className={classes.labelMobile} />
            <Grid
              item
              xs={12}
              textAlign={isLaptop ? 'left' : 'center'}
              alignSelf="flex-start"
              className={classes.containerTitle}
            >
              <Typography
                mb={isLaptop ? SPACES.xxxs : 0}
                fontWeight={'700'}
                fontSize={FONTS.SIZES.xxxxl}
              >
                <HelperWrapper t="sign-in-email-title" />
              </Typography>
            </Grid>
            <Formik
              initialValues={{
                email: email ?? '',
              }}
              autoComplete="off"
              onSubmit={handleSubmit}
              validationSchema={signInEmailSchema}
            >
              <Form>
                <SignInEmailForm isEmailTaken={verificationResp?.isEmailTaken} />
              </Form>
            </Formik>
          </Grid>
        </Grid>
      </AuthFormWrapper>
      <footer className={classes.footerWrapper}>
        <AppVersion />
      </footer>
    </Grid>
  )
}

export { SignInEmail }
